"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[74317],{

/***/ 22613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48761);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(100% - 14px);\n\n  .ant-slider-rail {\n    display: none;\n  }\n\n  .ant-slider-handle {\n    border: solid 2px ",
        ";\n  }\n\n  :hover .ant-slider-handle,\n  .ant-slider-handle:hover {\n    border-color: ",
        " !important;\n  }\n\n  .ant-slider-track {\n    height: 1px;\n    background-color: ",
        ";\n  }\n\n  :hover .ant-slider-track {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b8d003df-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary));


/***/ }),

/***/ 4881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);

function useScrollChat() {
    var highlightChat = function(id) {
        var bubbleElement = document.getElementById("".concat(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_BUBBLE_ID */ .H2, "-").concat(id));
        bubbleElement.classList.add("chat-highlight");
        setTimeout(function() {
            bubbleElement.classList.remove("chat-highlight");
        }, 3000);
    };
    var scrollToBottom = function() {
        setTimeout(function() {
            var contentElement = document.getElementById(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_CONTENT_CONTAINER_ID */ .mR);
            if (contentElement) {
                contentElement.scrollTo({
                    top: contentElement.scrollHeight,
                    behavior: "smooth"
                });
            }
        }, 50);
    };
    var scrollToChatBubble = function(id) {
        var bubbleId = "".concat(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_BUBBLE_ID */ .H2, "-").concat(id);
        var contentElement = document.getElementById(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_CONTENT_CONTAINER_ID */ .mR);
        var bubbleElement = document.getElementById(bubbleId);
        if (bubbleElement) {
            contentElement === null || contentElement === void 0 ? void 0 : contentElement.scrollTo({
                top: bubbleElement.offsetTop - contentElement.offsetTop - bubbleElement.offsetHeight * 0.1,
                behavior: "smooth"
            });
            highlightChat(id);
        } else {
            contentElement === null || contentElement === void 0 ? void 0 : contentElement.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            setTimeout(function() {
                scrollToChatBubble(id);
            }, 500);
        }
    };
    return {
        scrollToBottom: scrollToBottom,
        scrollToChatBubble: scrollToChatBubble,
        highlightChat: highlightChat
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useScrollChat);


/***/ }),

/***/ 37220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useGetReferralInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_api_community__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89561);
/* harmony import */ var stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7639);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);





var useGetReferralInfo = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return {
        isLoading: false,
        fetchCommunityInfo: function fetchCommunityInfo() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var remisierUI, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            remisierUI = stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().getUIValue("remisier");
                            if (!remisierUI) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            // If remisier UI is not exists, then we fetch from API
                            set({
                                isLoading: true
                            });
                            _ctx.next = 7;
                            return (0,lib_api_community__WEBPACK_IMPORTED_MODULE_1__/* .getReferralInfo */ .Qu)();
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error("failed to get community info");
                        case 10:
                            data = response.data.data;
                            stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().setUIValue("remisier", {
                                isLeader: data.is_leader,
                                isCommunityAccessGranted: data.enabled || data.is_leader
                            });
                            set({
                                isLoading: false
                            });
                            _ctx.next = 19;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            set({
                                isLoading: false
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }))();
        }
    };
});


/***/ }),

/***/ 60602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IX": function() { return /* binding */ AVATAR_SIZE; },
/* harmony export */   "Rm": function() { return /* binding */ ONBOARDING_MAX_STEP; },
/* harmony export */   "Wo": function() { return /* binding */ ONBOARDING_REQUEST_FILTER; }
/* harmony export */ });
var ONBOARDING_MAX_STEP = 4;
var AVATAR_SIZE = {
    BIG: "BIG",
    SMALL: "SMALL",
    PORTRAIT: "PORTRAIT"
};
// DISCOVER PEOPLE
var ONBOARDING_USER_SUGGEST_LIMIT = 30;
var ONBOARDING_USER_SUGGEST_PAGE = 1;
var ONBOARDING_USER_SUGGEST_FILTER = "FILTER_ONBOARDING";
var ONBOARDING_REQUEST_FILTER = {
    limit: ONBOARDING_USER_SUGGEST_LIMIT,
    page: ONBOARDING_USER_SUGGEST_PAGE,
    filter: ONBOARDING_USER_SUGGEST_FILTER
};



/***/ }),

/***/ 74317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/features/onboarding/constants.ts
var constants = __webpack_require__(60602);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
;// CONCATENATED MODULE: ./src/hooks/useOnBoarding.ts




function useOnBoarding() {
    var ref = (0,react.useState)(Infinity), onboardingProgress = ref[0], setOnboardingProgress = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref1.data;
    var progress = dataProfile.onboarding, statusOnboarding = dataProfile.onboarding_done;
    (0,react.useEffect)(function() {
        // redirect only if data profile is available
        if (dataProfile.id && statusOnboarding == 0 && progress <= constants/* ONBOARDING_MAX_STEP */.Rm) {
            setOnboardingProgress(progress);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        progress,
        statusOnboarding,
        dataProfile
    ]);
    return {
        onboardingProgress: onboardingProgress
    };
}
/* harmony default export */ var hooks_useOnBoarding = (useOnBoarding);

// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 3 modules
var credentials = __webpack_require__(64435);
// EXTERNAL MODULE: ./src/hooks/useProfileData.ts
var useProfileData = __webpack_require__(30995);
// EXTERNAL MODULE: ./src/hooks/useNotificationListener.ts
var useNotificationListener = __webpack_require__(91364);
// EXTERNAL MODULE: ./src/features/edit-profile/slice.ts
var slice = __webpack_require__(40927);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/global/Notification/index.tsx + 1 modules
var Notification = __webpack_require__(77667);
// EXTERNAL MODULE: ./src/features/chat/MainContent/useScrollChat.ts
var useScrollChat = __webpack_require__(4881);
// EXTERNAL MODULE: ./src/features/chat/store/index.ts + 7 modules
var store = __webpack_require__(77284);
// EXTERNAL MODULE: ./src/global/WebSocketV2/slice.ts + 1 modules
var WebSocketV2_slice = __webpack_require__(66250);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var chat_slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
// EXTERNAL MODULE: ./src/stores/chat/index.ts + 2 modules
var chat = __webpack_require__(50490);
// EXTERNAL MODULE: ./src/features/chat/utils.ts
var utils = __webpack_require__(33037);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
;// CONCATENATED MODULE: ./src/utils/socketSocial.ts



var transformToNotifMessage = function(rawText, type) {
    var text = sanitize_html_default()(rawText);
    var _obj;
    var attachmentContentMapper = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_PHOTO */.G0.ATTACHMENT_TYPE_PHOTO, " *IMAGE*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_GIF */.G0.ATTACHMENT_TYPE_GIF, " *GIF*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_POST */.G0.ATTACHMENT_TYPE_POST, " *POST*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_STICKER */.G0.ATTACHMENT_TYPE_STICKER, " *STICKER*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_PDF */.G0.ATTACHMENT_TYPE_PDF, ""), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED, ""), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_SHARETRADE */.G0.ATTACHMENT_TYPE_SHARETRADE, ""), _obj);
    text += attachmentContentMapper[type];
    return text;
};


;// CONCATENATED MODULE: ./src/hooks/useChatListenerWsSocialV2.ts
/* eslint-disable eqeqeq */ /* eslint-disable no-undef */ 



















var checkMessageDuplicated = function(messages, newRoomId, lastMessageId) {
    if (messages[newRoomId]) {
        var ref;
        return (ref = messages[newRoomId]) === null || ref === void 0 ? void 0 : ref.messages.some(function(chat) {
            return chat.id === lastMessageId;
        });
    }
    return false;
};
var checkMissingObjectText = function(body) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var chatMessageV1 = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatMessage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.message;
    var valueText = (chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref4 = chatMessageV1.body) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.conversation) === null || ref5 === void 0 ? void 0 : ref5.text) ? chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref6 = chatMessageV1.body) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.conversation) === null || ref7 === void 0 ? void 0 : ref7.text : "";
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1), {
        text: valueText,
        body: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1.body), {
            conversation: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref8 = chatMessageV1.body) === null || ref8 === void 0 ? void 0 : ref8.conversation), {
                text: valueText,
                attachmentType: (chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref9 = chatMessageV1.body) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.conversation) === null || ref10 === void 0 ? void 0 : ref10.attachmentType) || constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED
            })
        })
    });
};
var handleRefreshGroupRoom = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatId) {
        var hasRoomDetail, ref, groupId;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return store/* roomDetailStore.getState */.e.getState().refreshGroupRoomDetail(chatId);
                case 2:
                    hasRoomDetail = _ctx.sent;
                    if (!hasRoomDetail) {
                        _ctx.next = 9;
                        break;
                    }
                    ;
                    groupId = (ref = store/* roomDetailStore.getState */.e.getState().group[chatId]) === null || ref === void 0 ? void 0 : ref.id;
                    _ctx.next = 8;
                    return store/* groupMemberStore.getState */.VY.getState().fetchGroupMember(groupId, 0);
                case 8:
                    chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                        state.conversation.isLoading = false;
                    }));
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function handleRefreshGroupRoom(chatId) {
        return _ref.apply(this, arguments);
    };
}();
function useChatListenerWsSocialV2() {
    var isUserLogin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var dispatch = (0,es/* useDispatch */.I0)();
    var activeRoomId = (0,es/* useSelector */.v9)(chat_slice/* selectors */.wl).activeRoomId;
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), _notifications = ref.notifications, notif = _notifications.data;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataLoggedInUser = ref1.data;
    var newIncomingChatWsSocialV2 = (0,es/* useSelector */.v9)(WebSocketV2_slice/* chatWsSocialV2Selector */.WM);
    var messages = (0,chat/* default */.Z)(function(store) {
        return store.conversation.messages;
    });
    var defaultRooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.default.list;
    });
    var invitedRooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.invited.list;
    });
    var updateRoomListFromWS = (0,chat/* default */.Z)(function(store) {
        return store.updateRoomListFromWS;
    });
    var pushMessage = (0,chat/* default */.Z)(function(store) {
        return store.pushMessage;
    });
    var updateMessageFromWS = (0,chat/* default */.Z)(function(store) {
        return store.updateMessageFromWS;
    });
    var scrollToBottom = (0,useScrollChat/* default */.Z)().scrollToBottom;
    var actionChatRoom = function(incomingChat) {
        if (activeRoomId > 0) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            var body = incomingChat.body;
            var newMessage = checkMissingObjectText(body);
            var newRoom = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatMessage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.room;
            var referenceId = body === null || body === void 0 ? void 0 : (ref4 = body.event) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.chatMessage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref7 === void 0 ? void 0 : ref7.referenceId;
            var roomStatus = body === null || body === void 0 ? void 0 : (ref8 = body.event) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.chatMessage) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref11 === void 0 ? void 0 : ref11.roomStatus;
            newMessage = (0,utils/* snakelizeKeys */.t_)(newMessage);
            newRoom = (0,utils/* snakelizeKeys */.t_)(newRoom);
            var isDuplicated = messages ? checkMessageDuplicated(messages, newRoom === null || newRoom === void 0 ? void 0 : newRoom.id, newMessage === null || newMessage === void 0 ? void 0 : newMessage.id) : false;
            // Check if the event comes when user leave
            var isStateUnspecified = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.state) === constant/* StateChatList.ROOM_STATE_UNSPECIFIED */.Kn.ROOM_STATE_UNSPECIFIED;
            var isDeletedEvent = (newMessage === null || newMessage === void 0 ? void 0 : (ref12 = newMessage.body) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.conversation) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.flag) === null || ref14 === void 0 ? void 0 : ref14.is_deleted) ? newMessage === null || newMessage === void 0 ? void 0 : (ref15 = newMessage.body) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.conversation) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.flag) === null || ref17 === void 0 ? void 0 : ref17.is_deleted : false;
            if (!isDuplicated && !isStateUnspecified && !isDeletedEvent) {
                var ref18, ref19, ref20, ref21, ref22;
                var chatId = newRoom.id;
                // push message to state;
                pushMessage({
                    chatId: chatId,
                    message: newMessage,
                    reference_id: referenceId,
                    room_status: roomStatus,
                    room: newRoom
                });
                // scroll to bottom if in current active chat is receive new message
                var isChatPageShowed = router_default().asPath.includes("/chat/".concat(chatId)) || router_default().asPath.includes("/group-chat/".concat(chatId)) || router_default().asPath.includes("/broadcast-chat/".concat(chatId));
                var senderUserData = newMessage === null || newMessage === void 0 ? void 0 : (ref18 = newMessage.body) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.conversation) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.sender) === null || ref20 === void 0 ? void 0 : ref20.user;
                var senderUserName = senderUserData && senderUserData.username ? senderUserData.username : "";
                var isReceiver = senderUserName !== dataLoggedInUser.username;
                if (isChatPageShowed) {
                    var container = document.getElementById("chat-content-container");
                    var currentPos = container.scrollHeight - container.clientHeight - 200;
                    var currentlyScrollingUp = container.scrollTop < currentPos;
                    // when there is incoming message on receiver side, that is currently scrolling up
                    // don't scroll to bottom
                    if (isReceiver && !currentlyScrollingUp || !isReceiver) {
                        scrollToBottom();
                    }
                }
                // Handle event type message from ws in group chat
                // will refresh the room detail and member list
                var isCurrentPage = router_default().asPath.includes("/group-chat/".concat(chatId));
                var isEventMessage = (newMessage === null || newMessage === void 0 ? void 0 : newMessage.body_type) === constant/* MESSAGE_BODY_TYPE.MESSAGE_BODY_TYPE_EVENT */.dn.MESSAGE_BODY_TYPE_EVENT;
                var isNotLeaveEvent = ((newMessage === null || newMessage === void 0 ? void 0 : (ref21 = newMessage.body) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.event) === null || ref22 === void 0 ? void 0 : ref22.text) || "").toLowerCase() !== "you left";
                if (isCurrentPage && isEventMessage && isNotLeaveEvent) {
                    handleRefreshGroupRoom(chatId);
                }
            } else {
                // update message if id has available on convo,
                updateMessageFromWS({
                    chatId: newRoom.id,
                    messageId: newMessage.id,
                    message: newMessage
                });
            }
        }
    };
    var actionRoomList = function(incomingChat) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var body = incomingChat.body;
        var newRoom = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatRoomInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.room;
        newRoom = (0,utils/* snakelizeKeys */.t_)(newRoom);
        var messageId = newRoom === null || newRoom === void 0 ? void 0 : (ref4 = newRoom.last_message) === null || ref4 === void 0 ? void 0 : ref4.id;
        var isAccepted = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.state) === constant/* StateChatList.ROOM_STATE_ACCEPTED */.Kn.ROOM_STATE_ACCEPTED;
        var isPersonalChat = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) === constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL;
        var isBroadcast = // TODO: remove 3
        // While waiting for proto definition encoding is done,
        // we use number 3 as broadcast type,
        // Currently, BE is sending 3 instead of ROOM_TYPE_BROADCAST
        (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) === constant/* RoomTypeFromPayload.BROADCAST */._2.BROADCAST;
        var roomList = isAccepted ? defaultRooms : invitedRooms;
        var lastMessage = (0,immer_esm/* default */.ZP)(newRoom === null || newRoom === void 0 ? void 0 : newRoom.last_message, function(draft) {
            var ref, ref1, ref2, ref3;
            draft.text = (newRoom === null || newRoom === void 0 ? void 0 : (ref = newRoom.last_message) === null || ref === void 0 ? void 0 : ref.text) ? newRoom.last_message.text : "";
            draft.sender_username = ((ref1 = newRoom.last_message) === null || ref1 === void 0 ? void 0 : ref1.sender_username) || "";
            // Replace last message if user delete their own latest chat
            if ((newRoom === null || newRoom === void 0 ? void 0 : (ref2 = newRoom.last_message) === null || ref2 === void 0 ? void 0 : ref2.text) === "This message was deleted" && ((ref3 = newRoom.last_message) === null || ref3 === void 0 ? void 0 : ref3.sender_username) === dataLoggedInUser.username) {
                draft.text = "You deleted this message";
                draft.placeholder_mask.masked_text = "You deleted this message";
            }
        });
        // ws social not send sender userId
        var senderUserName = lastMessage.sender_username;
        var isReceiver = senderUserName !== dataLoggedInUser.username;
        var isEventMessage = isPersonalChat || isBroadcast ? false : !senderUserName;
        var roomIdx = roomList.findIndex(function(item) {
            return item.id === (newRoom === null || newRoom === void 0 ? void 0 : newRoom.id);
        });
        var isDuplicated = messages ? checkMessageDuplicated(messages, newRoom === null || newRoom === void 0 ? void 0 : newRoom.id, newRoom === null || newRoom === void 0 ? void 0 : (ref5 = newRoom.last_message) === null || ref5 === void 0 ? void 0 : ref5.id) : false;
        // existing chatroom
        if (roomIdx > -1) {
            var ref8, ref9, ref10;
            var roomInfo = isPersonalChat || isBroadcast ? roomList[roomIdx].info : (0,_object_spread/* default */.Z)({
                avatar_url: (newRoom === null || newRoom === void 0 ? void 0 : (ref8 = newRoom.info) === null || ref8 === void 0 ? void 0 : ref8.avatar_url) || ""
            }, newRoom === null || newRoom === void 0 ? void 0 : newRoom.info);
            var updateLastMessage = isDuplicated ? ((ref10 = (ref9 = messages[newRoom === null || newRoom === void 0 ? void 0 : newRoom.id]) === null || ref9 === void 0 ? void 0 : ref9.messages[0]) === null || ref10 === void 0 ? void 0 : ref10.id) === messageId : true;
            lastMessage = updateLastMessage ? lastMessage : roomList[roomIdx].last_message;
            var unreadCount = roomList[roomIdx].unread_count || 0;
            // counter unread count chat list
            if (!isEventMessage && isReceiver && !isDuplicated) {
                unreadCount = roomList[roomIdx].unread_count + 1;
            }
            newRoom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, roomList[roomIdx]), {
                last_message: lastMessage,
                info: roomInfo,
                unread_count: unreadCount,
                status: newRoom === null || newRoom === void 0 ? void 0 : newRoom.status,
                isBroadcast: isBroadcast
            });
        } else {
            var unreadCount1 = 0;
            // counter unread count chat list
            if (!isEventMessage && isReceiver && !isDuplicated) {
                unreadCount1 += 1;
            }
            newRoom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newRoom), {
                unread_count: unreadCount1,
                isBroadcast: isBroadcast
            });
        }
        // wont update the room list if the event is us leaving
        if ((newRoom === null || newRoom === void 0 ? void 0 : (ref6 = newRoom.lastMessage) === null || ref6 === void 0 ? void 0 : ref6.text) !== "You left") {
            updateRoomListFromWS(newRoom);
        }
        // Show Left Bottom Push Notification
        var isInvitedChat = newRoom.state === constant/* StateChatList.ROOM_STATE_INVITED */.Kn.ROOM_STATE_INVITED;
        var isMuted = newRoom.status.isMuted || false;
        var getCurrentIncomingNotifType = (ref7 = (0,utils/* getNotifType */.K5)(newRoom)) === null || ref7 === void 0 ? void 0 : ref7.notifType;
        var incomingMessageDataNotifSetting = notif.find(function(notifGroup) {
            return notifGroup.group === constant/* NOTIF_GROUP_CHAT */.wS;
        }).notifications.find(function(notifItem) {
            return notifItem.type === getCurrentIncomingNotifType;
        });
        if (isReceiver && !isMuted && incomingMessageDataNotifSetting) {
            var isDesktopNotificationTurnOn = incomingMessageDataNotifSetting.settings.find(function(setting) {
                return setting.key === constant/* NOTIF_SETTING_KEY_DN */.gK;
            }).value;
            if (isDesktopNotificationTurnOn) {
                var ref11, ref12, ref13, ref14, ref15, ref16;
                var groupChatName = (newRoom === null || newRoom === void 0 ? void 0 : (ref11 = newRoom.info) === null || ref11 === void 0 ? void 0 : ref11.name) || "Group Chat";
                var usernameAtGroup = senderUserName ? "".concat(senderUserName, " @") : "";
                var notifTitle = newRoom.type === constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL ? senderUserName : "".concat(usernameAtGroup, " ").concat(groupChatName);
                var lastMessageType = (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) || constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED;
                (0,Notification/* showChatNotification */.Ac)({
                    title: notifTitle,
                    description: transformToNotifMessage(lastMessage.text, lastMessageType),
                    isDeactivate: (newRoom === null || newRoom === void 0 ? void 0 : (ref12 = newRoom.attributes) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.personal) === null || ref13 === void 0 ? void 0 : ref13.is_deactivated) || false,
                    name: (newRoom === null || newRoom === void 0 ? void 0 : (ref14 = newRoom.info) === null || ref14 === void 0 ? void 0 : ref14.name) || "",
                    shortName: (newRoom === null || newRoom === void 0 ? void 0 : (ref15 = newRoom.info) === null || ref15 === void 0 ? void 0 : ref15.shortened_name) || "",
                    type: (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) || constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL,
                    avatar: (newRoom === null || newRoom === void 0 ? void 0 : (ref16 = newRoom.info) === null || ref16 === void 0 ? void 0 : ref16.avatar_url) || "",
                    id: (newRoom === null || newRoom === void 0 ? void 0 : newRoom.id) || 0,
                    key: "in-app-notification-".concat(newRoom === null || newRoom === void 0 ? void 0 : newRoom.id),
                    isPersonalChat: isPersonalChat,
                    isInvitedChat: isInvitedChat,
                    onClose: function() {
                        dispatch(WebSocketV2_slice/* default.actions.clearChat */.ZP.actions.clearChat());
                    }
                });
            }
        }
    };
    var _obj;
    var actionEventType = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constant/* EVENT_TYPE_BROADCAST.TYPE_CHAT_MESSAGE */.aw.TYPE_CHAT_MESSAGE, function(incomingChat) {
        return actionChatRoom(incomingChat);
    }), (0,_define_property/* default */.Z)(_obj, constant/* EVENT_TYPE_BROADCAST.TYPE_CHAT_ROOM_INFO */.aw.TYPE_CHAT_ROOM_INFO, function(incomingChat) {
        return actionRoomList(incomingChat);
    }), _obj);
    var actionTypeBroadCast = function(incomingChat) {
        var ref, ref1;
        var incomingBodyEventType = incomingChat === null || incomingChat === void 0 ? void 0 : (ref = incomingChat.body) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.type;
        return actionEventType[incomingBodyEventType] && actionEventType[incomingBodyEventType](incomingChat);
    };
    var chatListener = function(incomingChat) {
        if (incomingChat) {
            /* Additional information

        1. SEND MESSAGE
        When user send message to group room or personal room,
        ws will send event new messages as a sender so after
        that, we will update the slice conversations.

        2. OLD WEBSOCKET
        There is 3 version of WS, the old (M) that have been
        deprecated, the new (M2) and the latest one (M3).
        In this listener we will only use M3 as our WS event.
        To prevent doubled event sented to us, we use message.id
        as identifier to check if the message has been save in
        redux/slice or not.

        3. BODY TYPE OF EVENT
        Personal room and group room message now have same
        body payload. We dont need to transform the body.

       */ actionTypeBroadCast(incomingChat);
        }
    };
    (0,react.useEffect)(function() {
        if (!isUserLogin) {
            return;
        }
        // After check the behaviour, it more safe to use
        // synchronously process instead of asynchronous
        // when receive double events from ws
        // @ts-ignore
        chatListener(newIncomingChatWsSocialV2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        newIncomingChatWsSocialV2,
        isUserLogin
    ]);
    return null;
}
/* harmony default export */ var hooks_useChatListenerWsSocialV2 = (useChatListenerWsSocialV2);

// EXTERNAL MODULE: ./src/features/community/hooks/useGetReferralInfo.ts
var useGetReferralInfo = __webpack_require__(37220);
// EXTERNAL MODULE: ./src/stores/chat/useGetChatUnreadCount.ts
var useGetChatUnreadCount = __webpack_require__(9986);
// EXTERNAL MODULE: ./src/features/transaction/provider.tsx + 1 modules
var provider = __webpack_require__(207);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var TradingModal_constant = __webpack_require__(29097);
// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/lib/stores/tradingOperation.ts + 1 modules
var tradingOperation = __webpack_require__(31532);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/hooks/useGetPortfolioData.ts
var useGetPortfolioData = __webpack_require__(47002);
// EXTERNAL MODULE: ./src/global/TradingModal/OrderPlacedModal.tsx + 1 modules
var OrderPlacedModal = __webpack_require__(70536);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/types.ts
var types = __webpack_require__(20620);
// EXTERNAL MODULE: ./src/global/VirtualTrading/stores/useVirtualOrderStore.ts
var useVirtualOrderStore = __webpack_require__(72965);
// EXTERNAL MODULE: ./src/global/TableOrderbookWidget/components/modals/store.ts
var modals_store = __webpack_require__(8106);
// EXTERNAL MODULE: ./src/global/TableOrderbookWidget/components/modals/AmendBuy.tsx
var AmendBuy = __webpack_require__(21801);
// EXTERNAL MODULE: ./src/global/TableOrderbookWidget/components/modals/AmendSell.tsx
var AmendSell = __webpack_require__(53997);
// EXTERNAL MODULE: ./src/global/TableOrderbookWidget/components/modals/styled.ts
var styled = __webpack_require__(76828);
// EXTERNAL MODULE: ./src/global/TableOrderbookWidget/components/modals/SellAll.tsx
var SellAll = __webpack_require__(30492);
;// CONCATENATED MODULE: ./src/global/TableOrderbookWidget/components/modals/Withdraw.tsx












function Withdraw(param) {
    var visible = param.visible;
    var postTradeCancel = (0,tradingOperation/* default */.Z)().postTradeCancel;
    var isRealTrading = (0,useTradingAccount/* default */.Z)().isRealTrading;
    var ref = (0,modals_store/* default */.Z)(), orders = ref.orders, resetModal = ref.resetModal;
    var getOrderHistory = (0,tradingData/* default */.Z)().getOrderHistory;
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var withdrawOrders = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var submissions, results;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoading(true);
                        _ctx.prev = 1;
                        submissions = orders.map(function(order, i) {
                            var data = {
                                orderkey: "W-WITHDRAW-".concat(Date.now()),
                                symbol: order.symbol,
                                orderid: order.orderid,
                                gtc: 0,
                                isRealTrading: isRealTrading
                            };
                            return postTradeCancel(data);
                        });
                        _ctx.next = 5;
                        return Promise.all(submissions);
                    case 5:
                        results = _ctx.sent;
                        setIsLoading(false);
                        getOrderHistory(isRealTrading);
                        resetModal();
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                    case 14:
                        _ctx.prev = 14;
                        setIsLoading(false);
                        return _ctx.finish(14);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11,
                    14,
                    17
                ]
            ]);
        }));
        return function withdrawOrders() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        visible: visible,
        width: "520px",
        // @ts-expect-error
        cancelable: !isLoading,
        onCancel: resetModal,
        centered: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                pt: "20px",
                size: "18px",
                align: "center",
                children: "Withdraw"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                p: "20px",
                children: "Are you sure want to withdraw this order?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: resetModal,
                        style: {
                            width: "50%",
                            borderRadius: 0,
                            padding: 10
                        },
                        disabled: isLoading,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "primary",
                        loading: isLoading,
                        style: {
                            width: "50%",
                            borderRadius: 0,
                            padding: 10
                        },
                        disabled: isLoading,
                        onClick: withdrawOrders,
                        children: "Confirm"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var modals_Withdraw = (Withdraw);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
;// CONCATENATED MODULE: ./src/global/TableOrderbookWidget/components/modals/AmendPreviewVirtual.tsx
/* eslint-disable react/no-unescaped-entities */ /* eslint-disable no-param-reassign */ 











function AmendPreviewVirtual() {
    var data = (0,es/* useSelector */.v9)(profile/* selectors */.wl).data;
    var ref = (0,react.useState)(false), checked = ref[0], setChecked = ref[1];
    var ref1 = (0,modals_store/* default */.Z)(), symbol = ref1.symbol, price = ref1.price, orders = ref1.orders;
    var portfolioSymbol = (0,useGetPortfolioData/* default */.Z)(symbol, false, true);
    var dataPreview = {
        stock: "",
        amount: 0,
        lot: 0
    };
    if (orders.length) {
        dataPreview = orders.reduce(function(acc, cur) {
            var LOT = cur.order_total;
            var AMOUNT = cur.order_total * price;
            acc.stock = cur.symbol;
            acc.amount += AMOUNT;
            acc.lot += LOT;
            return acc;
        }, {
            stock: "",
            amount: 0,
            lot: 0
        });
    } else {
        dataPreview = {
            stock: symbol,
            amount: portfolioSymbol.available_lot * price,
            lot: portfolioSymbol.available_lot
        };
    }
    var previewData = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: "Stock"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: dataPreview.stock
            })
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: "Price"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: (0,number/* formatNumber */.uf)(price, false)
            })
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: "Amount"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: (0,number/* formatNumber */.uf)(dataPreview.amount, false)
            })
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "right",
                children: "Lot"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: (0,number/* formatNumber */.uf)(dataPreview.lot, false)
            })
        }, 
    ];
    var updateShowModal = function(isChecked) {
        if (isChecked) {
            var storeData = {
                id: data.id,
                status: isChecked
            };
            localStorage.setItem("trade-orderbook-show-confirmation", JSON.stringify(storeData));
        } else {
            localStorage.removeItem("trade-orderbook-show-confirmation");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                direction: "column",
                width: "100%",
                children: previewData.map(function(p) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                        className: "virtual",
                        children: [
                            p.label,
                            p.value
                        ]
                    }, "amend-buy-".concat(p.label));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ConfirmationBox */.cJ, {
                onClick: function() {
                    if (checked) {
                        setChecked(false);
                        updateShowModal(false);
                    } else {
                        setChecked(true);
                        updateShowModal(true);
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Checkbox */.XZ, {
                            items: "center",
                            justify: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: checked,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                    className: "icon-toolbar_check"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Don't show this confirmation again"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var modals_AmendPreviewVirtual = (AmendPreviewVirtual);

;// CONCATENATED MODULE: ./src/global/TableOrderbookWidget/components/modals/Amend.tsx
/* eslint-disable no-console */ 




























function Amend() {
    var ref = (0,react.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,tradingOperation/* default */.Z)(), postTradeAmend = ref1.postTradeAmend, postTradeSell = ref1.postTradeSell;
    var ref2 = (0,useTradingAccount/* default */.Z)(), isRealTrading = ref2.isRealTrading, isVirtualTrading = ref2.isVirtualTrading;
    var createVirtualOrder = (0,useVirtualOrderStore/* useVirtualOrderStore */.R)(function(s) {
        return s.createVirtualOrder;
    });
    var ref3 = (0,modals_store/* default */.Z)(), price = ref3.price, symbol = ref3.symbol, orderType = ref3.orderType, orders = ref3.orders, resetModal = ref3.resetModal, visible = ref3.visible;
    var portfolioSymbol = (0,useGetPortfolioData/* default */.Z)(symbol, false, true);
    var ref4 = (0,tradingData/* default */.Z)(function(s) {
        return {
            getOrderHistory: s.getOrderHistory,
            getPortfolio: s.getPortfolio,
            getConfigFormula: s.getConfigFormula
        };
    }, shallow/* default */.Z), getOrderHistory = ref4.getOrderHistory, getPortfolio = ref4.getPortfolio, getConfigFormula = ref4.getConfigFormula;
    var ref5 = (0,react.useState)(""), modalType = ref5[0], setModalType = ref5[1];
    var amend = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var MAX_BULK_AMEND, newOrders, chunksAmend, submissions, responses, responseError;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isVirtualTrading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setIsLoading(true);
                        _ctx.prev = 3;
                        MAX_BULK_AMEND = 100;
                        newOrders = orders;
                        chunksAmend = newOrders.reduce(function(chunks, order, index) {
                            var chunkIndex = Math.floor(index / MAX_BULK_AMEND);
                            if (!chunks[chunkIndex]) {
                                // eslint-disable-next-line no-param-reassign
                                chunks[chunkIndex] = [];
                            }
                            chunks[chunkIndex].push({
                                price: price,
                                order_id: order.orderid,
                                shares: Math.floor(order.order_total) * TradingModal_constant/* lotSize */.CQ
                            });
                            return chunks;
                        }, []);
                        submissions = chunksAmend.map(function(body) {
                            return postTradeAmend(body);
                        });
                        _ctx.next = 10;
                        return Promise.all(submissions);
                    case 10:
                        responses = _ctx.sent;
                        responseError = responses.find(function(resp) {
                            return resp.error;
                        });
                        getOrderHistory(isRealTrading, false);
                        getPortfolio(isRealTrading, false);
                        if (isRealTrading && responseError === undefined) {
                            setModalType(types/* MODAL_TYPE.ORDER_PLACED */.fG.ORDER_PLACED);
                        } else resetModal();
                        _ctx.next = 21;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](3);
                        ;
                        resetModal();
                    case 21:
                        _ctx.prev = 21;
                        setIsLoading(false);
                        return _ctx.finish(21);
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    17,
                    21,
                    24
                ]
            ]);
        }));
        return function amend() {
            return _ref.apply(this, arguments);
        };
    }();
    var sell = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (!isRealTrading) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 4;
                        return postTradeSell({
                            accountType: "stockbit",
                            orderkey: "W-SELL-".concat(Date.now()),
                            symbol: symbol,
                            price: price,
                            shares: Math.floor(portfolioSymbol === null || portfolioSymbol === void 0 ? void 0 : portfolioSymbol.available_lot) * TradingModal_constant/* lotSize */.CQ,
                            boardtype: "RG",
                            gtc: 0
                        });
                    case 4:
                        response = _ctx.sent;
                        if (!(response.error === undefined)) {
                            _ctx.next = 9;
                            break;
                        }
                        {
                            setModalType(types/* MODAL_TYPE.ORDER_PLACED */.fG.ORDER_PLACED);
                        }
                        _ctx.next = 10;
                        break;
                    case 9:
                        throw Error();
                    case 10:
                        if (!isVirtualTrading) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 13;
                        return createVirtualOrder("sell", symbol, {
                            gtc: false,
                            price: Number(price),
                            shares: Math.floor(portfolioSymbol === null || portfolioSymbol === void 0 ? void 0 : portfolioSymbol.available_lot) * TradingModal_constant/* lotSize */.CQ,
                            tradeshare: false
                        });
                    case 13:
                        setModalType(types/* MODAL_TYPE.ORDER_PLACED */.fG.ORDER_PLACED);
                    case 14:
                        _ctx.next = 20;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        resetModal();
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    16
                ]
            ]);
        }));
        return function sell() {
            return _ref.apply(this, arguments);
        };
    }();
    var onConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isLoading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL) {
                            sell();
                        } else {
                            amend();
                        }
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (visible) {
            if (orderType === "WITHDRAW") {
                setModalType("WITHDRAW");
            } else if (orderType === types/* MODAL_TYPE.ORDER_PLACED */.fG.ORDER_PLACED) {
                setModalType(types/* MODAL_TYPE.ORDER_PLACED */.fG.ORDER_PLACED);
            } else if (!isRealTrading) {
                var checkConfirmation = localStorage.getItem("trade-orderbook-show-confirmation");
                if (checkConfirmation) {
                    var getStatus = JSON.parse(checkConfirmation);
                    if ((getStatus === null || getStatus === void 0 ? void 0 : getStatus.status) === true) {
                        onConfirm();
                    } else {
                        setModalType(types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                    }
                } else {
                    setModalType(types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                }
            } else {
                setModalType(types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
            }
        } else {
            setModalType("");
        }
    }, [
        visible,
        orderType
    ]);
    (0,react.useEffect)(function() {
        if (modalType === types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION && isRealTrading) {
            getConfigFormula();
        }
    }, [
        modalType,
        isRealTrading
    ]);
    if (!visible) return null;
    var _obj;
    var title = (_obj = {}, (0,_define_property/* default */.Z)(_obj, trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY, "Buy"), (0,_define_property/* default */.Z)(_obj, trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL, "Sell"), (0,_define_property/* default */.Z)(_obj, trading/* ORDER_TYPE.SELL */.Jm.SELL, "Sell"), _obj);
    var _obj1;
    var colors = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY, color/* default.primary */.Z.primary), (0,_define_property/* default */.Z)(_obj1, trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL, color/* default.sunsetOrange */.Z.sunsetOrange), (0,_define_property/* default */.Z)(_obj1, trading/* ORDER_TYPE.SELL */.Jm.SELL, color/* default.sunsetOrange */.Z.sunsetOrange), _obj1);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modals_Withdraw, {
                visible: modalType === "WITHDRAW"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderPlacedModal/* default */.Z, {
                visible: modalType === types/* MODAL_TYPE.ORDER_PLACED */.fG.ORDER_PLACED,
                onSubmit: resetModal,
                orderType: null,
                symbol: symbol,
                onCloseModal: function() {
                    return setModalType("");
                },
                onReturnToTransaction: resetModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                visible: modalType === types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION,
                onCancel: resetModal,
                centered: true,
                width: "500px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        family: "bold",
                        size: "21px",
                        // @ts-expect-error
                        pt: "20px",
                        pb: "20px",
                        color: colors[orderType],
                        align: "center",
                        children: [
                            "Preview ",
                            title[orderType]
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isRealTrading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            direction: "column",
                            align: "center",
                            padding: "0 30px 30px 30px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/previeworder-icon.svg",
                                    alt: "order-preview"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewContainer */.ph, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                            condition: orderType === trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AmendBuy/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                            condition: orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AmendSell/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                            condition: orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SellAll/* default */.Z, {
                                                onCancel: resetModal
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !isRealTrading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modals_AmendPreviewVirtual, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            position: "absolute",
                            bottom: "-50px",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: onConfirm,
                            loading: isLoading,
                            radius: "4px",
                            block: true,
                            height: "40px",
                            style: {
                                background: colors[orderType],
                                borderColor: colors[orderType]
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                align: "inherit",
                                color: color/* default.light */.Z.light,
                                family: "bold",
                                size: "18px",
                                children: [
                                    isRealTrading ? "Place" : "Set",
                                    " Order"
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var modals_Amend = (Amend);

// EXTERNAL MODULE: ./src/global/MainLayout/styled.ts
var MainLayout_styled = __webpack_require__(92589);
// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var MainLayout_slice = __webpack_require__(48153);
;// CONCATENATED MODULE: ./src/global/MainLayout/__tests__/constant.ts
var DATA_CY_MAIN_LAYOUT = "main-layout";

;// CONCATENATED MODULE: ./src/global/MainLayout/index.tsx
/* eslint-disable react/forbid-prop-types */ 










// Local Components








// import webSocketSlice from 'global/WebSocketV2/slice';



// local redux slice


var HeaderWeb = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2678), __webpack_require__.e(92342), __webpack_require__.e(71682), __webpack_require__.e(91622), __webpack_require__.e(71421), __webpack_require__.e(77060), __webpack_require__.e(73671)]).then(__webpack_require__.bind(__webpack_require__, 73671));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73671)
            ];
        }
    },
    ssr: false
});
var HeaderMobile = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2678), __webpack_require__.e(92342), __webpack_require__.e(71682), __webpack_require__.e(91622), __webpack_require__.e(71421), __webpack_require__.e(12127)]).then(__webpack_require__.bind(__webpack_require__, 12127));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12127)
            ];
        }
    },
    ssr: false
});
var SideWidget = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(46312), __webpack_require__.e(74749), __webpack_require__.e(6581), __webpack_require__.e(25586)]).then(__webpack_require__.bind(__webpack_require__, 69908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69908)
            ];
        }
    },
    ssr: false
});
var OnBoarding = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(29306), __webpack_require__.e(74645), __webpack_require__.e(89111), __webpack_require__.e(91086)]).then(__webpack_require__.bind(__webpack_require__, 91086));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91086)
            ];
        }
    },
    ssr: false
});
var ModalTransactionSecurities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(60296), __webpack_require__.e(80822), __webpack_require__.e(98294), __webpack_require__.e(57008), __webpack_require__.e(33271), __webpack_require__.e(74645), __webpack_require__.e(71682), __webpack_require__.e(91727), __webpack_require__.e(64180), __webpack_require__.e(84623), __webpack_require__.e(91853), __webpack_require__.e(13799), __webpack_require__.e(69962), __webpack_require__.e(35153), __webpack_require__.e(18657)]).then(__webpack_require__.bind(__webpack_require__, 39337));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39337)
            ];
        }
    },
    ssr: false
});
var ModalAuthSecurities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(61980), __webpack_require__.e(77435), __webpack_require__.e(15740), __webpack_require__.e(62366), __webpack_require__.e(69975)]).then(__webpack_require__.bind(__webpack_require__, 62366));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62366)
            ];
        }
    },
    ssr: false
});
var ModalShareTradeManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33082), __webpack_require__.e(98294), __webpack_require__.e(62526), __webpack_require__.e(686), __webpack_require__.e(24516), __webpack_require__.e(41883)]).then(__webpack_require__.bind(__webpack_require__, 61785));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61785)
            ];
        }
    },
    ssr: false
});
var GlobalModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(23304), __webpack_require__.e(33082), __webpack_require__.e(63828), __webpack_require__.e(80822), __webpack_require__.e(61980), __webpack_require__.e(80139), __webpack_require__.e(74673), __webpack_require__.e(15740), __webpack_require__.e(77596), __webpack_require__.e(77697), __webpack_require__.e(62739), __webpack_require__.e(92119), __webpack_require__.e(94200)]).then(__webpack_require__.bind(__webpack_require__, 10951));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10951)
            ];
        }
    },
    ssr: false
});
var ModalBonds = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33082), __webpack_require__.e(80822), __webpack_require__.e(61980), __webpack_require__.e(98294), __webpack_require__.e(34328), __webpack_require__.e(71682), __webpack_require__.e(91727), __webpack_require__.e(57539)]).then(__webpack_require__.bind(__webpack_require__, 14426));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14426)
            ];
        }
    },
    ssr: false
});
var ModalUnavailable = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 15994).then(__webpack_require__.bind(__webpack_require__, 15994));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15994)
            ];
        }
    },
    ssr: false
});
var ModalErrorManager = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 51906).then(__webpack_require__.bind(__webpack_require__, 51906));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51906)
            ];
        }
    },
    ssr: false
});
var MultiPortoModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(98294), __webpack_require__.e(44975)]).then(__webpack_require__.bind(__webpack_require__, 44975));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44975)
            ];
        }
    },
    ssr: false
});
var StreamErrorModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(61980), __webpack_require__.e(15740), __webpack_require__.e(38458)]).then(__webpack_require__.bind(__webpack_require__, 91011));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91011)
            ];
        }
    },
    ssr: false
});
var DatafeedModalManager = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 80329).then(__webpack_require__.bind(__webpack_require__, 80329));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80329)
            ];
        }
    },
    ssr: false
});
var InsufficientTradingBalanceModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 20802).then(__webpack_require__.bind(__webpack_require__, 20802));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20802)
            ];
        }
    },
    ssr: false
});
function MainLayout(param) {
    var children = param.children, isFlexibleWidth = param.isFlexibleWidth, maxWidth = param.maxWidth, background = param.background, width = param.width, _fullPage = param.fullPage, fullPage = _fullPage === void 0 ? false : _fullPage;
    // Library hooks
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var breakpoints = (0,useBreakpoint/* default */.Z)();
    // Zustand store
    var ref = (0,useGetChatUnreadCount/* useGetChatUnreadCount */.H)(function(s) {
        return {
            fetchChatUnreadCount: s.fetchUnreadCount,
            isChatUnreadCountReset: s.isReset
        };
    }), fetchChatUnreadCount = ref.fetchChatUnreadCount, isChatUnreadCountReset = ref.isChatUnreadCountReset;
    var fetchCommunityInfo = (0,useGetReferralInfo/* useGetReferralInfo */.s)(function(s) {
        return s.fetchCommunityInfo;
    });
    // Redux store
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var ref1 = (0,es/* useSelector */.v9)(MainLayout_slice/* selectors */.wl), isSideWidgetOpen = ref1.isSideWidgetOpen, isHeaderMinimized = ref1.isHeaderMinimized, isMarketOpen = ref1.isMarketOpen;
    // Custom hooks
    var onboardingProgress = hooks_useOnBoarding().onboardingProgress;
    (0,useProfileData/* default */.Z)();
    (0,useNotificationListener/* default */.Z)(isLoggedIn);
    hooks_useChatListenerWsSocialV2(isLoggedIn);
    // Reactive variable
    var isShowOnboarding = onboardingProgress < constants/* ONBOARDING_MAX_STEP */.Rm;
    var props = width ? {
        style: {
            width: width
        }
    } : {};
    (0,react.useEffect)(function() {
        if (!isLoggedIn) {
            return;
        }
        // During route changes or reload:
        // re-fetch unread chat if state is haven't reset
        // or clear chat data if state have reset
        // if (!isChatUnreadCountReset) {
        //   fetchChatUnreadCount();
        // } else {
        //   dispatch(webSocketSlice.actions.clearChat());
        // }
        fetchChatUnreadCount();
        fetchCommunityInfo();
        dispatch(slice/* effects.getNotifications */.Sz.getNotifications());
    }, [
        isLoggedIn
    ]);
    (0,react.useEffect)(function() {
        var hash = window.location.hash;
        var pathname = router.pathname;
        if (pathname !== "/" && hash.startsWith("#/")) {
            var strippedUrl = hash.replace("#", "");
            if (router.pathname.includes(strippedUrl) || strippedUrl.includes(router.pathname)) {
                router.replace(router.pathname);
            } else {
                router.push(strippedUrl);
            }
        }
    }, []);
    // React render
    if (isShowOnboarding) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoarding, {
            progress: onboardingProgress
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-cy": DATA_CY_MAIN_LAYOUT,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(provider/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout_styled/* WrapperMainContent */.UI, {
                            isSideWidgetOpen: isSideWidgetOpen,
                            isMarketOpen: isMarketOpen,
                            children: [
                                breakpoints.md ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWeb, {
                                    isSideWidgetOpen: isSideWidgetOpen,
                                    isMarketOpen: isMarketOpen,
                                    isHeaderMinimized: isHeaderMinimized
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobile, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout_styled/* Wrapper */.im, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    background: background,
                                    isSideWidgetOpen: isSideWidgetOpen
                                }, props), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout_styled/* default */.ZP, {
                                        id: "main-container",
                                        isFlexibleWidth: isFlexibleWidth,
                                        maxWidth: maxWidth,
                                        isSideWidgetOpen: isSideWidgetOpen,
                                        fullPage: fullPage,
                                        isMarketOpen: isMarketOpen,
                                        children: children
                                    })
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAuthSecurities, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTransactionSecurities, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTradeManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUnavailable, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiPortoModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamErrorModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InsufficientTradingBalanceModal, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DatafeedModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modals_Amend, {})
            ]
        })
    });
}
MainLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    isFlexibleWidth: (prop_types_default()).bool,
    maxWidth: (prop_types_default()).number,
    background: (prop_types_default()).string,
    width: (prop_types_default()).any
};
MainLayout.defaultProps = {
    isFlexibleWidth: false,
    maxWidth: undefined,
    background: "transparent",
    width: undefined
};
/* harmony default export */ var global_MainLayout = (MainLayout);


/***/ }),

/***/ 92589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RU": function() { return /* binding */ SIDE_WIDGET_OPENED_WIDTH; },
/* harmony export */   "U9": function() { return /* binding */ SIDE_WIDGET_CONTENT_WIDTH; },
/* harmony export */   "UI": function() { return /* binding */ WrapperMainContent; },
/* harmony export */   "Uh": function() { return /* binding */ device; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "zX": function() { return /* binding */ SIDE_WIDGET_TOOLBAR_WIDTH; }
/* harmony export */ });
/* unused harmony export Container */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74575);
/* eslint-disable space-infix-ops */ /* eslint-disable indent */ /* eslint-disable no-confusing-arrow */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      @media ",
        " {\n        width: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 40px auto 0 auto;\n  padding: ",
        ";\n  width: 100%;\n  max-width: ",
        ";\n\n  &.chat-expanded {\n    margin: 0 auto 0 auto !important;\n    padding: 0 !important;\n  }\n\n  ",
        "\n\n  @media ",
        " {\n    margin: 100px auto 0;\n    max-width: ",
        ";\n\n    &.chat-expanded {\n      margin: 0px auto 0 auto !important;\n      padding: 20px 37px 0 0 !important;\n    }\n  }\n\n  @media ",
        " {\n    max-width: ",
        ";\n    &:has(#academy-iframe) {\n      position: absolute !important;\n      left: 0;\n      padding-bottom: 0;\n      width: 100% !important;\n      max-width: ",
        ";\n      margin: ",
        ";\n    }\n  }\n\n  @media screen and (min-width: 1500px) {\n    margin: 100px auto 0 auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  @media ",
        " {\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


// TODO: Update device dimension to DS
var laptopM = "(min-width:1081px)";
var device = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    laptopM: laptopM
});
var SIDE_WIDGET_CONTENT_WIDTH = "380px";
var SIDE_WIDGET_TOOLBAR_WIDTH = "48px";
var SIDE_WIDGET_OPENED_WIDTH = "428px";
// prettier-ignore
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].main.withConfig */ .ZP.main.withConfig({
    componentId: "sc-fad2ded0-0"
})(_templateObject1(), function(props) {
    return props.fullPage ? "0" : "20px 0";
}, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "990px";
}, function(props) {
    return props.isFlexibleWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), device.tablet, props.isMarketOpen ? "calc(100% - 60px)" : "calc(100% - 100px)");
}, device.tablet, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "660px";
}, device.laptopM, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "990px";
}, function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen, isMarketOpen = param.isMarketOpen;
    return function() {
        if (!isSideWidgetOpen) {
            return "unset";
        }
        if (!isMarketOpen) {
            return "calc(100% - 425px) !important";
        }
        return "calc(100% - 365px) !important";
    }();
}, function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen;
    return isSideWidgetOpen && "auto !important";
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fad2ded0-1"
})(_templateObject2(), function(props) {
    return props.background ? props.background : "transparent";
});
var WrapperMainContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fad2ded0-2"
})(_templateObject3(), device.tablet, function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen, isMarketOpen = param.isMarketOpen;
    return function() {
        if (!isSideWidgetOpen) {
            return "calc(100% - ".concat(SIDE_WIDGET_TOOLBAR_WIDTH, ") ");
        }
        if (!isMarketOpen) {
            return "calc(100% - 425px)";
        }
        return "calc(100% - ".concat(SIDE_WIDGET_OPENED_WIDTH, ")");
    }();
});
/* harmony default export */ __webpack_exports__["ZP"] = (Container);


/***/ }),

/***/ 21801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62974);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36902);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8106);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76828);
/* eslint-disable no-eval */ /* eslint-disable no-param-reassign */ 






function AmendBuyPreview() {
    var ref = (0,lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), _configFormula = ref.configFormula, formula = _configFormula.data.formula;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), price = ref.price, orders = ref.orders;
    var dataPreview = orders.reduce(function(acc, cur) {
        var LOT = cur.order_total;
        var PRICE = price;
        var FEE_BUY = formula.fee_buy;
        var BUY_AMOUNT = eval(formula.buy_amount_invested); // nosemgrep
        var BUY_AMOUNT_FEE = eval(formula.buy_amount_invested_fee); // nosemgrep
        var BUY_FEE = eval(formula.buy_amount_fee); // nosemgrep
        acc.stock = cur.symbol;
        acc.price = PRICE;
        acc.lot += LOT;
        acc.investment += BUY_AMOUNT;
        acc.fee += BUY_FEE;
        acc.total_investment += BUY_AMOUNT_FEE;
        return acc;
    }, {
        stock: "",
        price: 0,
        lot: 0,
        investment: 0,
        fee: 0,
        total_investment: 0
    });
    var previewData = [
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: "Stock"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                family: "bold",
                children: dataPreview.stock
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: "Price"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: (0,utils_number__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(dataPreview.price, false)
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: "Lot"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: (0,utils_number__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(dataPreview.lot, false)
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: "Investment"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: [
                    "Rp ",
                    (0,utils_number__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(dataPreview.investment, false)
                ]
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: "Fee"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: [
                    "Rp ",
                    (0,utils_number__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(dataPreview.fee, false)
                ]
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                family: "bold",
                children: "Investment (Plus Fee)"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                family: "bold",
                children: [
                    "Rp ",
                    (0,utils_number__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(dataPreview.total_investment, false)
                ]
            })
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        direction: "column",
        width: "100%",
        children: previewData.map(function(p) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .PreviewItem */ .s8, {
                children: [
                    p.label,
                    p.value
                ]
            }, "amend-buy-".concat(p.label));
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AmendBuyPreview);


/***/ }),

/***/ 53997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62974);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36902);
/* harmony import */ var hooks_useGetPortfolioData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47002);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42227);
/* harmony import */ var global_Securities_utils_formula__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98202);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83153);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8106);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76828);
/* eslint-disable no-param-reassign */ /* eslint-disable no-eval */ 











function AmendSellPreview() {
    var ref;
    var ref = (0,lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), company = ref.company, _configFormula = ref.configFormula, formula = _configFormula.data.formula;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(), price = ref.price, symbol = ref.symbol, orders = ref.orders;
    var portfolioSymbol = (0,hooks_useGetPortfolioData__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(symbol, false, true);
    var productType = (company === null || company === void 0 ? void 0 : (ref = company.data) === null || ref === void 0 ? void 0 : ref.type_company) || "";
    var isCorporateAction = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return constants_trading__WEBPACK_IMPORTED_MODULE_9__/* .CorporateActionStockType.includes */ .dB.includes(productType.toLowerCase());
    }, [
        productType
    ]);
    var dataPreview = orders.reduce(function(acc, cur) {
        var LOT = cur.order_total;
        var PRICE = price;
        var FEE_SELL = formula.fee_sell;
        var SELL_FEE = eval(formula.sell_amount_fee); // nosemgrep
        var SELL_AMOUNT = eval(formula.sell_amount_invested); // nosemgrep
        var SELL_AMOUNT_FEE = eval(formula.sell_amount_invested_fee); // nosemgrep
        var sellAmountInvestedFee = (0,global_Securities_utils_formula__WEBPACK_IMPORTED_MODULE_8__/* .getSellAmountInvestedFee */ .B1)(LOT, price, isCorporateAction);
        var buyAmountInvested = (0,global_Securities_utils_formula__WEBPACK_IMPORTED_MODULE_8__/* .getBuyAmountInvested */ .yq)(LOT, portfolioSymbol ? portfolioSymbol.price_average_fee : 0);
        var sellProfitLoss = (0,global_Securities_utils_formula__WEBPACK_IMPORTED_MODULE_8__/* .getProfitLoss */ .fY)(sellAmountInvestedFee, buyAmountInvested);
        var sellGain = (0,global_Securities_utils_formula__WEBPACK_IMPORTED_MODULE_8__/* .getSellGain */ .Sd)(sellProfitLoss, buyAmountInvested);
        acc.stock = cur.symbol;
        acc.price = PRICE;
        acc.lot += LOT;
        acc.fee += SELL_FEE;
        acc.proceed_amount += SELL_AMOUNT;
        acc.total_proceeds += SELL_AMOUNT_FEE;
        acc.sellPL += sellProfitLoss;
        acc.sellGain += sellGain;
        return acc;
    }, {
        stock: "",
        price: 0,
        lot: 0,
        fee: 0,
        proceed_amount: 0,
        total_proceeds: 0,
        sellPL: 0,
        sellGain: 0
    });
    var previewData = [
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: "Stock"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                family: "bold",
                children: dataPreview.stock
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: "Lot"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: (0,utils_number__WEBPACK_IMPORTED_MODULE_4__/* .formatNumber */ .uf)(dataPreview.lot, false)
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: "Price"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: (0,utils_number__WEBPACK_IMPORTED_MODULE_4__/* .formatNumber */ .uf)(dataPreview.price, false)
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: "Proceed Amount"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: [
                    "Rp ",
                    (0,utils_number__WEBPACK_IMPORTED_MODULE_4__/* .formatNumber */ .uf)(dataPreview.proceed_amount, false)
                ]
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: "Fee"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: [
                    "Rp ",
                    (0,utils_number__WEBPACK_IMPORTED_MODULE_4__/* .formatNumber */ .uf)(dataPreview.fee, false)
                ]
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                family: "bold",
                as: "span",
                children: "Total Proceeds"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                family: "bold",
                as: "span",
                children: [
                    "Rp ",
                    (0,utils_number__WEBPACK_IMPORTED_MODULE_4__/* .formatNumber */ .uf)(dataPreview.total_proceeds, false)
                ]
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: "Profit/Loss"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                color: (0,utils_general__WEBPACK_IMPORTED_MODULE_7__/* .getColorBasedOnNumber */ .pV)(dataPreview.sellPL),
                children: [
                    (0,utils_number__WEBPACK_IMPORTED_MODULE_4__/* .formatNumber */ .uf)(dataPreview.sellPL, false),
                    " (",
                    dataPreview.sellPL > 0 && "+",
                    (0,utils_number__WEBPACK_IMPORTED_MODULE_4__/* .formatPercentage */ .rl)(dataPreview.sellGain, false),
                    ")"
                ]
            })
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        direction: "column",
        width: "100%",
        children: previewData.map(function(p) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .PreviewItem */ .s8, {
                children: [
                    p.label,
                    p.value
                ]
            }, "amend-sell-".concat(p.label));
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AmendSellPreview);


/***/ }),

/***/ 30492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95541);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62974);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36902);
/* harmony import */ var hooks_useGetPortfolioData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47002);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42227);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83153);
/* harmony import */ var global_Securities_utils_formula__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98202);
/* harmony import */ var global_Securities_components_SkeletonWrapper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27607);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(41080);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(76828);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8106);
/* eslint-disable no-eval */ 















function SellAllPreview(param) {
    var _onCancel = param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel;
    var ref;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isCompanyLoading = ref[0], setCompanyLoading = ref[1];
    var ref = (0,lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), company = ref.company, _configFormula = ref.configFormula, formula = _configFormula.data.formula, getCompany = ref.getCompany;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(), price = ref.price, symbol = ref.symbol;
    var portfolioSymbol = (0,hooks_useGetPortfolioData__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(symbol, false, true);
    var productType = (company === null || company === void 0 ? void 0 : (ref = company.data) === null || ref === void 0 ? void 0 : ref.type_company) || "";
    var isCorporateAction = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return constants_trading__WEBPACK_IMPORTED_MODULE_9__/* .CorporateActionStockType.includes */ .dB.includes(productType.toLowerCase());
    }, [
        productType
    ]);
    var LOT = Math.floor(portfolioSymbol.available_lot);
    var PRICE = price;
    var sellAmountInvestedFee = (0,global_Securities_utils_formula__WEBPACK_IMPORTED_MODULE_10__/* .getSellAmountInvestedFee */ .B1)(LOT, price, isCorporateAction);
    var buyAmountInvested = (0,global_Securities_utils_formula__WEBPACK_IMPORTED_MODULE_10__/* .getBuyAmountInvested */ .yq)(LOT, portfolioSymbol ? portfolioSymbol.price_average_fee : 0);
    var sellProfitLoss = (0,global_Securities_utils_formula__WEBPACK_IMPORTED_MODULE_10__/* .getProfitLoss */ .fY)(sellAmountInvestedFee, buyAmountInvested);
    var sellGain = (0,global_Securities_utils_formula__WEBPACK_IMPORTED_MODULE_10__/* .getSellGain */ .Sd)(sellProfitLoss, buyAmountInvested);
    var FEE_SELL = formula.fee_sell;
    var SELL_FEE = eval(formula.sell_amount_fee); // nosemgrep
    var SELL_AMOUNT = eval(formula.sell_amount_invested); // nosemgrep
    var previewData = [
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: "Stock"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                family: "bold",
                children: symbol
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: "Lot"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: (0,utils_number__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(LOT, false)
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: "Price"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: (0,utils_number__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(PRICE, false)
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: "Proceed Amount"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: [
                    "Rp ",
                    (0,utils_number__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(SELL_AMOUNT, false)
                ]
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: "Fee"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: [
                    "Rp ",
                    (0,utils_number__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(SELL_FEE, false)
                ]
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                family: "bold",
                children: "Total Proceeds"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                family: "bold",
                children: [
                    "Rp",
                    " ",
                    (0,utils_number__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)((0,global_Securities_utils_formula__WEBPACK_IMPORTED_MODULE_10__/* .getSellAmountInvestedFee */ .B1)(LOT, price, isCorporateAction), false)
                ]
            })
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: "Profit/Loss"
            }),
            value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                color: (0,utils_general__WEBPACK_IMPORTED_MODULE_8__/* .getColorBasedOnNumber */ .pV)(sellProfitLoss),
                children: [
                    (0,utils_number__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(sellProfitLoss, false),
                    " (",
                    sellProfitLoss > 0 && "+",
                    (0,utils_number__WEBPACK_IMPORTED_MODULE_5__/* .formatPercentage */ .rl)(sellGain, false),
                    ")"
                ]
            })
        }, 
    ];
    var loadCompanyData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    setCompanyLoading(true);
                    _ctx.next = 4;
                    return getCompany(symbol);
                case 4:
                    setCompanyLoading(false);
                    _ctx.next = 10;
                    break;
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    onCancel();
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    })), [
        symbol
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        loadCompanyData();
    }, [
        loadCompanyData
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        direction: "column",
        width: "100%",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Securities_components_SkeletonWrapper__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            skeleton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                title: false,
                paragraph: {
                    rows: 6,
                    style: {
                        margin: "20px"
                    }
                },
                active: true
            }),
            loading: isCompanyLoading,
            children: previewData.map(function(p) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_12__/* .PreviewItem */ .s8, {
                    children: [
                        p.label,
                        p.value
                    ]
                }, "sell-all-".concat(p.label));
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SellAllPreview);


/***/ }),

/***/ 8106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* eslint-disable import/no-named-as-default-member */ 


var initialState = {
    visible: false,
    symbol: null,
    price: null,
    orderType: null,
    orders: []
};
var orderbookModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        showModal: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                visible: true
            }, payload));
        },
        resetModal: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (orderbookModalStore);


/***/ }),

/***/ 76828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "cJ": function() { return /* binding */ ConfirmationBox; },
/* harmony export */   "ph": function() { return /* binding */ PreviewContainer; },
/* harmony export */   "s8": function() { return /* binding */ PreviewItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: 50% 50%;\n  transition: all 0.3s ease;\n  padding: 5px 10px;\n  width: 100%;\n\n  &.virtual {\n    grid-template-columns: 35% 65%;\n    grid-gap: 20px;\n\n    p:last-child {\n      color: #000;\n    }\n  }\n\n  &:not(.virtual):not(:last-child) {\n    border-bottom: 1px solid #f5f6f7;\n  }\n\n  &:not(.virtual) {\n    &:hover {\n      cursor: pointer;\n      background: #f5f6f7;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border: 1px solid #ededed;\n  border-radius: 5px;\n  margin: 30px 0px 0px 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border: none;\n  background: transparent;\n  border-top: 1px solid #dadada;\n  padding: 10px;\n  margin: 30px 0px 0px 0px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 20px;\n  height: 20px;\n  border: 1px solid #dadada;\n  border-radius: 2px;\n  margin-right: 10px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var PreviewItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-cf294a64-0"
})(_templateObject());
var PreviewContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-cf294a64-1"
})(_templateObject1());
var ConfirmationBox = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-cf294a64-2"
})(_templateObject2());
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cf294a64-3"
})(_templateObject3());


/***/ }),

/***/ 70536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TradingModal_OrderPlacedModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/features/sharetrade/stores/useShareTradeModal.ts
var useShareTradeModal = __webpack_require__(77064);
;// CONCATENATED MODULE: ./src/global/Icons/ShareSvg.tsx

var ShareSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_7968_43563)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.25 10V14.6666C5.25 14.976 5.37292 15.2728 5.59171 15.4916C5.8105 15.7104 6.10724 15.8333 6.41666 15.8333H13.4166C13.726 15.8333 14.0228 15.7104 14.2415 15.4916C14.4603 15.2728 14.5833 14.976 14.5833 14.6666V10",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.2501 6.49982L9.91681 4.1665L7.5835 6.49982",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.91663 4.1665V11.7498",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_7968_43563",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(0.25)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_ShareSvg = (ShareSvg);

// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/lib/analytics/autoOrder.ts
var autoOrder = __webpack_require__(66959);
// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
// EXTERNAL MODULE: ./src/features/sharetrade/analytics/shareTradeShareTracker.ts
var shareTradeShareTracker = __webpack_require__(56371);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(34400);
// EXTERNAL MODULE: ./src/global/TradingModal/styled.ts
var styled = __webpack_require__(76805);
;// CONCATENATED MODULE: ./src/global/TradingModal/OrderPlacedModal.tsx





















var OrderPlacedModal = function(param) {
    var visible = param.visible, onSubmit = param.onSubmit, onReturnToTransaction = param.onReturnToTransaction, onCloseModal = param.onCloseModal, orderType = param.orderType, symbol = param.symbol, _returnTransactionLabel = param.returnTransactionLabel, returnTransactionLabel = _returnTransactionLabel === void 0 ? "Return to Orderbook" : _returnTransactionLabel;
    var pathname = (0,router.useRouter)().pathname;
    var isChartbit = pathname.includes("/chartbit");
    var isAmend = (0,react.useMemo)(function() {
        return orderType === trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY || orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
    }, [
        orderType
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.orderType,
            s.resetShareTradeModal
        ];
    }, shallow/* default */.Z), 2), shareOrderType = ref[0], resetShareTradeModal = ref[1];
    var isShowShareButton = (0,react.useMemo)(function() {
        return !isAmend && [
            transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder,
            transaction/* SellOrderType.LimitOrder */.qK.LimitOrder
        ].includes(shareOrderType);
    }, [
        isAmend,
        shareOrderType
    ]);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.isVisible,
            s.setIsVisible,
            s.setSharedUsers
        ];
    }, shallow/* default */.Z), 3), isShareTradeVisible = ref1[0], setIsShareTradeVisible = ref1[1], setSharedUsers = ref1[2];
    var isOrderModalVisible = (0,react.useMemo)(function() {
        return visible && !isShareTradeVisible;
    }, [
        visible,
        isShareTradeVisible
    ]);
    var handleSubmit = function() {
        resetShareTradeModal();
        setSharedUsers({});
        if (isChartbit) onCloseModal();
        if (!isChartbit) onSubmit();
    };
    var handleShareTradeClick = function() {
        setIsShareTradeVisible(true);
        (0,shareTradeShareTracker/* trackOrderShareSelected */.M1)(orderType, symbol);
    };
    (0,react.useEffect)(function() {
        // don't track if the modal is visible and it is a bond transaction
        if (!visible || orderType === trading/* ORDER_TYPE.BOND */.Jm.BOND) {
            return;
        }
        if (orderType) {
            (0,securities/* clevertapOrderReceived */.dQ)({
                orderType: orderType
            });
            (0,autoOrder/* trackAutoBuyOrderReceivedView */.Bi)();
        }
    }, [
        visible
    ]);
    (0,useKeyPress/* default */.Z)([
        "Enter"
    ], function() {
        if (isOrderModalVisible) handleSubmit();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        visible: isOrderModalVisible,
        width: "420px",
        onCancel: onCloseModal,
        centered: true,
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/modal-close.svg"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                direction: "column",
                align: "center",
                padding: "40px 32px 20px 32px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/icon/preview-order-sent.svg",
                        alt: "order-sent",
                        style: {
                            marginBottom: 16
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "18px",
                        family: "bold",
                        children: "Order Sent"
                    }),
                    isShowShareButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justify: "center",
                        margin: "16px 0 0 0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ShareTradeButton */.Ae, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                component: Icons_ShareSvg
                            }),
                            type: "borderless",
                            onClick: handleShareTradeClick,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                align: "inherit",
                                color: "inherit",
                                family: "bold",
                                size: "14px",
                                children: "Share Trade"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                padding: "20px",
                children: [
                    !isAmend && !isChartbit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onReturnToTransaction,
                        type: "default",
                        radius: "4px",
                        block: true,
                        height: "44px",
                        margin: "0 8px 0 0",
                        style: {
                            borderColor: color/* default.downgray */.Z.downgray
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            align: "inherit",
                            color: color/* default.primary */.Z.primary,
                            family: "bold",
                            size: "14px",
                            children: returnTransactionLabel
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleSubmit,
                        type: "primary",
                        radius: "4px",
                        block: true,
                        height: "44px",
                        margin: "0 0 0 8px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            align: "inherit",
                            color: "inherit",
                            family: "bold",
                            size: "14px",
                            children: "Done"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TradingModal_OrderPlacedModal = (OrderPlacedModal);


/***/ }),

/***/ 76805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A5": function() { return /* binding */ FeeItem; },
/* harmony export */   "Ae": function() { return /* binding */ ShareTradeButton; },
/* harmony export */   "QX": function() { return /* binding */ ModalTabText; },
/* harmony export */   "Qi": function() { return /* binding */ InvestmentWrapper; },
/* harmony export */   "Rn": function() { return /* binding */ InputNumber; },
/* harmony export */   "VA": function() { return /* binding */ PreviewContainer; },
/* harmony export */   "VV": function() { return /* binding */ FreezeLayer; },
/* harmony export */   "W4": function() { return /* binding */ ButtonWrapper; },
/* harmony export */   "W_": function() { return /* binding */ ModalFormWrapper; },
/* harmony export */   "__": function() { return /* binding */ PreviewModalContainer; },
/* harmony export */   "a7": function() { return /* binding */ ModalTab; },
/* harmony export */   "hK": function() { return /* binding */ ModalLitContent; },
/* harmony export */   "iV": function() { return /* binding */ SwitchWrapper; },
/* harmony export */   "lX": function() { return /* binding */ FormLabel; },
/* harmony export */   "md": function() { return /* binding */ TransactionModalContainer; },
/* harmony export */   "n5": function() { return /* binding */ FormWrapper; },
/* harmony export */   "ph": function() { return /* binding */ FormHeader; },
/* harmony export */   "s8": function() { return /* binding */ PreviewItem; },
/* harmony export */   "sg": function() { return /* binding */ OrderButton; },
/* harmony export */   "ww": function() { return /* binding */ PreviewItemRow; },
/* harmony export */   "yH": function() { return /* binding */ InvestmentDetail; }
/* harmony export */ });
/* unused harmony exports FormItemWrapper, Tag, Slider, OrderPlacedConfirmWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_trading_Slider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22613);
/* harmony import */ var _deprecated_ui_trading_InputNumber__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4377);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22147);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62974);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 480px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-modal-content {\n    border-radius: 6px 6px 0 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 100%;\n  .ant-modal-close {\n    top: 8px;\n  }\n\n  .ant-modal-close-icon {\n    svg {\n      width: 14px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 15px;\n\n  &.has-border {\n    border-bottom: 1px solid ",
        ";\n    padding-bottom: 15px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: stretch;\n  align-items: center;\n  border-radius: 2px;\n  background: ",
        ";\n  color: ",
        ";\n  padding: 0 8px;\n  font-weight: bold;\n  min-height: 25px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px;\n  background: ",
        ";\n  border-radius: 4px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n\n  .ant-input-number-input {\n    padding: 0px !important;\n  }\n\n  .ant-input-number-handler-wrap {\n    width: 0px !important;\n  }\n\n  .ant-input-number-handler-up {\n    border-left: 1px solid ",
        ";\n    left: ",
        ";\n  }\n\n  .ant-input-number-handler-down {\n    border-right: 1px solid ",
        ";\n    left: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  transition: all 0.3s ease;\n  gap: 8px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  > div {\n    border-color: #f2f1fe;\n    background-color: #f2f1fe;\n    color: #8277f8;\n    padding: 2px 6px;\n    margin-right: 2px;\n    display: flex;\n    gap: 2px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 6px 12px;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  gap: 4px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid #f5f6f7;\n  &:hover {\n    cursor: pointer;\n    background: #f5f6f7;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 40%;\n  text-align: right;\n  padding-right: 30px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-slider-track {\n    background-color: ",
        " !important;\n    height: 3px;\n    top: 5px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  background: ",
        "80;\n  height: 92%;\n  z-index: 100;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  left: 0;\n  bottom: -16px;\n  width: 100%;\n  transform: translateY(100%);\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n  cursor: pointer;\n  margin: ",
        " -20px -10px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 4px;\n  height: 44px;\n\n  background: ",
        ";\n  color: ",
        ";\n  border-color: ",
        ";\n\n  &.ant-btn-secondary {\n    background-color: ",
        ";\n    border-color: ",
        ";\n  }\n\n  & p {\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 19px;\n    color: inherit;\n    text-align: inherit;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  height: 51px;\n  width: 50%;\n  border-radius: 3px 3px 0 0;\n  background: ",
        ";\n  border-bottom: ",
        ";\n\n  :first-child {\n    border-right: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0;\n  color: #00ab6b;\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: #00ab6b;\n  }\n\n  & .anticon {\n    width: 20px;\n    height: 20px;\n    font-size: 20px;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -16px;\n  transform: translateY(100%);\n\n  & > button {\n    margin: 0px 8px;\n\n    :first-child { \n      margin-left: 0;\n    }\n\n    :last-child { \n      margin-right: 0;\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 0;\n  background-color: transparent;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  \n  .container {\n    background-color: #fff;\n    border-radius: 4px;\n  \n    .info {\n      padding: 40px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n  \n      padding: 40px 0;\n      gap: 16px;\n    };\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}









var ModalFormWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-0"
})(_templateObject());
var PreviewModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-1"
})(_templateObject1());
var TransactionModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    width: "auto",
    type: "transparent",
    centered: true
}).withConfig({
    componentId: "sc-f4de7892-2"
})(_templateObject2());
var FormHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var FormItemWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-4"
})(_templateObject4());
var Tag = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].nightRider */ .Z.nightRider, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light);
var FormWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-6"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light);
var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_trading_InputNumber__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs({
    formatter: function(value) {
        return (0,utils_number__WEBPACK_IMPORTED_MODULE_8__/* .formatNumber */ .uf)(value.replace(/\D/g, ""), false);
    },
    parser: function(value) {
        return value.replace(/[, ]+/g, "").trim();
    }
}).withConfig({
    componentId: "sc-f4de7892-7"
})(_templateObject7(), function(props) {
    // @ts-expect-error
    if (props.isForTriggerPrice) return "63px !important";
    return "100px !important";
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, // @ts-expect-error
function(param) {
    var isForTriggerPrice = param.isForTriggerPrice;
    if (isForTriggerPrice) return "-1px !important";
    return "0px !important";
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, // @ts-expect-error
function(param) {
    var isForTriggerPrice = param.isForTriggerPrice;
    if (isForTriggerPrice) return "-91px !important";
    return "-130px !important";
});
var PreviewContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-8"
})(_templateObject8());
var PreviewItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    width: "100%",
    justify: "space-between",
    align: "center",
    py: "3px"
}).withConfig({
    componentId: "sc-f4de7892-9"
})(_templateObject9());
var PreviewItemRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    justify: "center",
    align: "center",
    gap: "4px"
}).withConfig({
    componentId: "sc-f4de7892-10"
})(_templateObject10());
var InvestmentWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    width: "100%",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-f4de7892-11"
})(_templateObject11());
var InvestmentDetail = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    direction: "column",
    width: "100%"
}).withConfig({
    componentId: "sc-f4de7892-12"
})(_templateObject12(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var FeeItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    width: "100%",
    align: "center",
    justify: "space-between",
    py: "2px"
}).withConfig({
    componentId: "sc-f4de7892-13"
})(_templateObject13());
var FormLabel = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.attrs */ .ZP.div.attrs({
    align: "right",
    pr: "30px"
}).withConfig({
    componentId: "sc-f4de7892-14"
})(_templateObject14());
var Slider = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_trading_Slider__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-15"
})(_templateObject15(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].sunsetorange */ .Z.sunsetorange);
var FreezeLayer = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-16"
})(_templateObject16(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light);
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-17"
})(_templateObject17());
var SwitchWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "center",
    height: "40px"
}).withConfig({
    componentId: "sc-f4de7892-18"
})(_templateObject18(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro, function(props) {
    return(// @ts-expect-error
    props.isOverlimit ? "50px" : "25px");
});
var OrderButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-19"
})(_templateObject19(), function(param) {
    var disabled = param.disabled;
    if (disabled) return "#616161 !important";
    return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary;
}, function(param) {
    var disabled = param.disabled;
    if (disabled) return "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].lowgray */ .Z.lowgray, "!important");
    return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light;
}, function(param) {
    var disabled = param.disabled;
    if (disabled) return "#616161 !important";
    return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].primary */ .Z.primary;
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].sunsetOrange */ .Z.sunsetOrange);
var ModalTab = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-20"
})(_templateObject20(), function(param) {
    var isActive = param.isActive;
    return isActive ? _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].light */ .Z.light : _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].component */ .Z.component;
}, function(param) {
    var isActive = param.isActive;
    return !isActive && "1px solid ".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_7__/* ["default"].gainsboro */ .Z.gainsboro);
var ModalTabText = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    family: "bold",
    size: "24px",
    height: "50px",
    align: "center"
}).withConfig({
    componentId: "sc-f4de7892-21"
})(_templateObject21());
var ShareTradeButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-22"
})(_templateObject22());
var OrderPlacedConfirmWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f4de7892-23"
})(_templateObject23());
var ModalLitContent = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4de7892-24"
})(_templateObject24());



/***/ }),

/***/ 72965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useVirtualOrderStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var _api_order__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79397);




var useVirtualOrderStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set, get) {
    return {
        isLoading: false,
        message: "",
        data: [],
        error: "",
        createVirtualOrder: function createVirtualOrder(orderType, symbol, form) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isLoading, response, data, orderIds;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isLoading = get().isLoading;
                            if (!isLoading) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 7;
                            return (0,_api_order__WEBPACK_IMPORTED_MODULE_1__/* .postVirtualOrder */ .$C)(orderType, symbol, form);
                        case 7:
                            response = _ctx.sent;
                            data = response.data.data;
                            orderIds = "order_id" in data ? [
                                data.order_id
                            ] : data.order_ids;
                            set({
                                isLoading: false,
                                data: orderIds
                            });
                            _ctx.next = 17;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        },
        createVirtualAmendOrder: function createVirtualAmendOrder(form) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isLoading, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isLoading = get().isLoading;
                            if (!isLoading) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 7;
                            return (0,_api_order__WEBPACK_IMPORTED_MODULE_1__/* .postVirtualAmendOrder */ .__)(form);
                        case 7:
                            response = _ctx.sent;
                            data = response.data.data;
                            set({
                                isLoading: false,
                                data: [
                                    data.order_id
                                ]
                            });
                            _ctx.next = 16;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }))();
        }
    };
});


/***/ }),

/***/ 34400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useKeyPress; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useKeyPress() {
    var keys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], callback = arguments.length > 1 ? arguments[1] : void 0;
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    var pressedKeysRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Set());
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function() {
        callbackRef.current = callback;
    });
    var handleKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(event) {
        pressedKeysRef.current.add(event.key);
        // Check if all keys in the combination are pressed
        if (keys.every(function(key) {
            return pressedKeysRef.current.has(key);
        })) {
            callbackRef.current();
        }
    }, [
        keys
    ]);
    var handleKeyUp = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(event) {
        pressedKeysRef.current.delete(event.key);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, [
        handleKeyDown,
        handleKeyUp
    ]);
};


/***/ }),

/***/ 89561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "By": function() { return /* binding */ deleteReferral; },
/* harmony export */   "ER": function() { return /* binding */ getReferralStatus; },
/* harmony export */   "H5": function() { return /* binding */ postApplyReferral; },
/* harmony export */   "KT": function() { return /* binding */ getReferralByCode; },
/* harmony export */   "Qu": function() { return /* binding */ getReferralInfo; },
/* harmony export */   "ve": function() { return /* binding */ getReferralMembers; }
/* harmony export */ });
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var request = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestWithoutAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].noAlert */ .Z.noAlert;
var getReferralInfo = function() {
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/info"));
};
var getReferralStatus = function() {
    return requestWithoutAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/status"));
};
var getReferralByCode = function(code) {
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/").concat(code));
};
var getReferralMembers = function(param) {
    var keyword = param.keyword, status = param.status, startDate = param.startDate, endDate = param.endDate, cursor = param.cursor;
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/affiliate/members"), {
        params: {
            search: keyword !== "" ? keyword : undefined,
            status: status !== "MEMBER_STATUS_UNSPECIFIED" ? status : undefined,
            start_date: startDate,
            end_date: endDate,
            cursor: cursor
        }
    });
};
var postApplyReferral = function(code) {
    return request.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/apply"), {
        code: code
    });
};
var deleteReferral = function() {
    return request.delete("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral"));
};
var communityAPI = {
    getReferralInfo: getReferralInfo,
    getReferralStatus: getReferralStatus,
    getReferralByCode: getReferralByCode,
    getReferralMembers: getReferralMembers,
    postApplyReferral: postApplyReferral,
    deleteReferral: deleteReferral
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (communityAPI)));


/***/ })

}]);